module.exports = __webpack_public_path__ + "img/suqian_s.a4b8c7f.png";